import { render, staticRenderFns } from "./ShowDispatch.vue?vue&type=template&id=01d399ec"
import script from "./ShowDispatch.vue?vue&type=script&lang=js"
export * from "./ShowDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports